'use client';

import { ReactComponent as RockXLogo } from '#/assets/icons/logo/rockx.svg';
import { Button } from '#/components/ui/button';
import { SidebarHeader } from '#/components/ui/sidebar';
import { cn } from '#/lib/utils';
import { X } from 'lucide-react';
import { useAppSidebarStore } from './app-sidebar-store';

export function AppSidebarHeader() {
  const sidebar = useAppSidebarStore(state => state.sidebar);
  return (
    <SidebarHeader
      className={cn({
        hidden: !sidebar?.isMobile,
      })}
    >
      <div className="flex justify-between gap-2">
        <div className="p-4">
          <RockXLogo className="w-32 h-8 text-[#23195F]" />
        </div>
        <Button
          data-sidebar="trigger"
          variant="ghost"
          size="icon"
          className="h-7 w-7 rounded-full"
          onClick={() => {
            sidebar?.toggleSidebar();
          }}
        >
          <X />
          <span className="sr-only">Toggle Sidebar</span>
        </Button>
      </div>
    </SidebarHeader>
  );
}
